import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removePrefixPipe' })
export class RemovePrefixPipe implements PipeTransform {
	transform(value: string): string {
		// Do the stuff to remove the domain name in the value
		return value.split('.').pop();
	}
}
